import { AnyAction, Dispatch } from 'redux';
import { EMPTY, Observable, Subscription, catchError, filter, switchMap } from 'rxjs';
import { ServerSentEventConnectionError } from 'src/services/ServerSentEvents/ServerSentEventErrors';
import { EventSourceContext } from 'src/services/ServerSentEvents/ServerSentEventSource.types';

export abstract class BaseEventSource {
  // total of 3 tries before entering failure state
  static MAX_RECONNECT_ATTEMPTS = 2;

  // 5 seconds
  static RETRY_DELAY = 5000;

  protected abstract context: EventSourceContext;

  constructor(protected onErrorCallback: (error: ServerSentEventConnectionError) => void) {}

  protected abstract streamListener(dispatch: Dispatch<AnyAction>, message: Event): void;

  protected abstract eventSource(accessToken: string): Observable<Event>;

  protected createEventSource = (token: string): Observable<Event> => {
    return this.eventSource(token).pipe(
      catchError((_error) => {
        // provided error has no useful info, create custom error for callback
        const sseError = new ServerSentEventConnectionError(this.context);
        this.onErrorCallback(sseError);
        return EMPTY;
      }),
    );
  };

  public connect = (dispatch: Dispatch<AnyAction>, accessToken$: Observable<string>): Subscription => {
    return (
      accessToken$
        // this prevents attempting to connect when we *clear* the accessToken (since...there is no accessToken)
        .pipe(filter((token) => token != null && token.length > 0))
        .pipe(switchMap(this.createEventSource))
        .subscribe((ev) => this.streamListener(dispatch, ev))
    );
  };
}
